import axios from 'axios'
import { useApiResources } from '../../hooks/useApiResources/useApiResources'
import { useApiResourcesPostprocessor } from '../../hooks/useApiResources/useApiResourcesPostprocessor'
import { useHttpRequest } from '../../hooks/useHttpRequest/useHttpRequest'

export const apiResponseResourcesNormalizer = (normalizer) => {
  return (responseData) => {
    let resourcesList = []

    if (!responseData) {
      return []
    }

    if (responseData.resources) {
      const { resources } = responseData
      resourcesList = resources
    }

    if (Array.isArray(responseData)) {
      resourcesList = responseData
    }

    return {
      ...responseData,
      resources: resourcesList.map((item) =>
        Object.keys(normalizer).reduce((accumulator, currentKey) => {
          const currentValue = normalizer[currentKey]

          return {
            ...accumulator,
            [currentKey]:
              typeof currentValue === 'function'
                ? currentValue(item)
                : item[currentValue],
          }
        }, {}),
      ),
    }
  }
}

const transformApiResponse = (responseData) => {
  let transformedResponseData = responseData

  if (responseData.meta && responseData.rows) {
    const {
      pagination: {
        rows_count: paginationResourcesCount,
        rows_per_page: paginationResourcesPerPage,
        total_pages_count: paginationTotalPagesCount,
        total_rows_count: paginationTotalResourcesCount,
      } = {},
    } = responseData.meta

    transformedResponseData = {
      meta: {
        pagination: {
          resourcesCount: paginationResourcesCount,
          resourcesPerPage: paginationResourcesPerPage,
          totalPagesCount: paginationTotalPagesCount,
          totalResourcesCount: paginationTotalResourcesCount,
        },
      },
      resources: responseData.rows,
    }
  }

  return transformedResponseData
}

export const useApplicationApiRequest = (url, options = {}) => {
  const { transformResponse = [], ...requestOptions } = options

  const requestTransformResponse = [
    ...axios.defaults.transformResponse,
    transformApiResponse,
    ...transformResponse,
  ]

  /* eslint-disable global-require */
  return useHttpRequest(url, {
    baseUrl: require('../constants/legacy').LEGACY_API_URL,
    transformResponse: requestTransformResponse,
    ...requestOptions,
  })
  /* eslint-enable global-require */
}

export const useApplicationApiResources = useApiResources

export const useApplicationApiResourcesPostprocessor = useApiResourcesPostprocessor
